import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import PageMeta from "../../components/common/PageMeta";
import { useEffect, useState } from "react";
import Spinner from "../../components/ui/Spinner";
import {
    API_BASE_URL,
    API_URL,
    DEFAULT_PAGE_DESCRIPTION,
    DEFAULT_PAGE_TITLE,
} from "../../utilities/constants";
import { useLocation, useNavigate, useParams } from "react-router";
import useQueryParams from "../../hooks/useQueryParams";
import { handleApiCall } from "../../utilities/helper";
import { useUI } from "../../context/UI";
import { CopyIcon } from "../../icons";
import LeaderCard from "./LeaderCards";

const InsiderDetails = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [stylists, setStylist] = useState(null);
    const navigate = useNavigate();
    const { updateQueryParam, queryParams } = useQueryParams();
    const location = useLocation();
    const { id } = useParams();
    const {
        setSegmentTitle,
        addToastMessage,
        addNotification,
        setNewNotification
    } = useUI();
    const [controller, setController] = useState(null);

    const callListApi = async () => {
        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);
        try {
            const response = await handleApiCall(
                `${API_BASE_URL}/api/backoffice/insidercircle/insider/${id}`,
                {
                    method: "GET"
                },
                null,
                signal
            );
            if (response.responseStatus == true) {
                setData(response.data);
                // Extract stylistIds from the API response
                const stylistIds = response.data?.quizSessions
                    ?.filter(session => session.status === "COMPLETED")
                    ?.map(session => session.matchedStylistId);

                console.log("stylistIds:", stylistIds);

                if (stylistIds?.length) {
                    await callStylistListApi(stylistIds); // call the stylist API
                }
            } else {
                setData(null);
            }
            if (response.responseCode !== 299) {
                setLoading(false);
            }
        } catch (e) {
            console.error("Error", e);
        } finally {
            setLoading(false);
        }
    };
    const stylistIds = data?.quizSessions
        ?.filter(session => session.status === "COMPLETED")
        ?.map(session => session.matchedStylistId);
    const matchedStylistIds = data?.quizSessions
        ?.filter(s => s.status === "COMPLETED" && s.matchedStylistId)
        .map(s => s.matchedStylistId);
    useEffect(() => {
        if (matchedStylistIds?.length > 0) {
            Promise.all(
                matchedStylistIds.map(id =>
                    fetch(`${API_BASE_URL}/api/1.0.0/aistylist/v2/stylist/${id}`).then(res => res.json())
                )
            ).then(setStylist);
        }
    }, []);

    const callStylistListApi = async (stylistIds) => {
        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);

        try {
            if (!stylistIds?.length) {
                setStylist();
                setLoading(false);
                return;
            }

            const responses = await Promise.all(
                stylistIds?.map(id =>
                    handleApiCall(
                        `${API_BASE_URL}/api/1.0.0/aistylist/v2/stylist/${id}`,
                        { method: "GET" },
                        null,
                        signal
                    )
                )
            );

            // Extract valid stylist data
            const validStylists = responses
                .filter(res => res?.responseStatus === true) // only successful responses
                ?.map(res => res.data); // get the actual stylist data

            console.log('validStylists', validStylists);
            console.log('responses', responses);
            setStylist(validStylists[0] || null);

            // setStylist(validStylists);
            console.log('stylist', stylists);


        } catch (e) {
            console.error("Error", e);
            setStylist([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        callListApi();
        setSegmentTitle("Insider Details");

        const stylistIds = data?.quizSessions
            ?.filter(session => session.status === "COMPLETED")
            ?.map(session => session.matchedStylistId);

        // callStylistListApi(stylistIds);
    }, []);

    console.log("STYLISTTT", stylists);

    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        if (data?.refCode) {
            navigator.clipboard.writeText(data?.refCode);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // reset after 2s
        }
    };

    return (
        <>
            <PageMeta
                title={`Insider Details - ${DEFAULT_PAGE_TITLE}`}
                description={`Insider Details - ${DEFAULT_PAGE_DESCRIPTION}`}
            />

            <div className="flex justify-between items-center mb-4">
                <PageBreadcrumb
                    pageTitle="Insider Details"
                    breadcrumbs={[
                        { label: "Insiders", path: "/insider-dashboard" },
                        { label: "Insider Details" }
                    ]}
                />
            </div>
            {loading ? (
                <div className="flex justify-center items-center">
                    <Spinner />
                </div>
            ) : (
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 overflow-auto">

                    <div className="flex flex-col md:flex-row gap-8">
                        <div className="flex flex-col items-center md:items-start gap-6 w-full md:w-1/6">
                            {/* Profile Image */}
                            <div className="w-40 h-40 overflow-hidden rounded-lg bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
                                <img
                                    src={
                                        data?.profile?.profile?.profileDpSignedUrl
                                            ? data.profile?.profile?.profileDpSignedUrl
                                            : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                                `${data?.firstName || ""} ${data?.lastName || ""}`
                                            )}&background=a8936a&color=fff`
                                    }
                                    alt="Profile"
                                    className="w-full h-full object-scale-down"
                                />
                            </div>

                            <div className="space-y-4 w-full">
                                <div className="space-y-4 w-full">
                                    <div>
                                        <h3 className="text-sm text-gray-500 dark:text-gray-400">Full Name</h3>
                                        <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                                            {data?.firstName} {data?.lastName}
                                        </p>
                                    </div>
                                    <div>
                                        <h3 className="text-sm text-gray-500 dark:text-gray-400">Email</h3>
                                        <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                                            {data?.email}
                                        </p>
                                    </div>
                                    <div>
                                        <h3 className="text-sm text-gray-500 dark:text-gray-400">Referral Code</h3>
                                        <p className="flex items-center text-base font-medium text-gray-900 dark:text-gray-100 gap-2">
                                            {data?.refCode}

                                            <div
                                                className="flex items-center justify-center w-8 h-8 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer"
                                                onClick={handleCopy}
                                            >
                                                <CopyIcon
                                                    className={`size-5 transition-colors ${copied
                                                        ? " text-green-600 dark:text-green-400"
                                                        : "text-gray-800 dark:text-white/90"
                                                        }`}
                                                />
                                            </div>

                                            {copied && (
                                                <span className="ml-2 text-sm text-green-600 dark:text-green-400">
                                                    Copied!
                                                </span>
                                            )}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="space-y-2  md:flex-row ">
                            {data?.quizSessions
                                ?.filter(s => s.status === "COMPLETED" && s?.matchedStylistId)
                                .map(session => {
                                    return (
                                        <>
                                            <div
                                                key={session?.sessionId}
                                                className="flex-1 flex flex-col md:flex-row md:gap-12 gap-2"
                                            >
                                                <div className="flex-[.5] md:pl-8 md:border-l border-gray-200 dark:border-gray-700 pr-2">
                                                    <div className="flex items-center justify-between mb-4">
                                                        <h3 className="text-md font-semibold text-gray-800 dark:text-gray-100">
                                                            Quiz {session?.sessionId}
                                                        </h3>
                                                        <div className="flex items-center gap-2 text-sm">
                                                            <span
                                                                className={`px-2 py-1 rounded-md text-xs font-medium
                                                                    ${session?.status === "COMPLETED"
                                                                        ? "bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-200"
                                                                        : session?.status === "STARTED"
                                                                            ? "bg-amber-100 text-amber-700 dark:bg-amber-800 dark:text-amber-200"
                                                                            : "bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-200"
                                                                    }`}
                                                            >
                                                                {session?.status === "COMPLETED"
                                                                    ? "Taken"
                                                                    : session?.status === "STARTED"
                                                                        ? "Started"
                                                                        : "Not Taken"}
                                                            </span>
                                                            {session?.completedAt && (
                                                                <span className="text-gray-500 dark:text-gray-400 text-xs">
                                                                    {new Date(session?.completedAt).toLocaleString()}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="max-h-[400px] overflow-y-auto">
                                                        <div className="space-y-1">
                                                            {Object.entries(session?.answers)
                                                                .sort(([a], [b]) => {
                                                                    const numA = parseInt(a.replace("Q", ""), 12);
                                                                    const numB = parseInt(b.replace("Q", ""), 12);
                                                                    return numA - numB;
                                                                })
                                                                .map(([q, ans]) => (
                                                                    <div
                                                                        key={q}
                                                                        className="p-4 rounded-lg bg-gray-50 dark:bg-gray-800 shadow-sm"
                                                                    >
                                                                        <h4 className="text-sm text-gray-500 dark:text-gray-400">{q}</h4>
                                                                        <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                                                                            {ans}
                                                                        </p>
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    </div>
                                                </div>

                                                {stylists && (
                                                    <div className="flex-[.5] flex flex-col gap-6 items-center">
                                                        <div className="flex flex-col items-center text-center">
                                                            <h2 className="text-xl font-semibold text-gray-800 dark:text-white">
                                                                {stylists.displayName}
                                                            </h2>
                                                            <p className="text-sm text-gray-600 dark:text-gray-300">
                                                                {stylists.persona}
                                                            </p>
                                                            <p className="text-xs text-gray-400 dark:text-gray-500">
                                                                {stylists.ethos}
                                                            </p>
                                                        </div>

                                                        <div className="w-full max-w-[250px]">
                                                            <LeaderCard
                                                                images={stylists.media
                                                                    ?.filter(m => m.mediaType === "PROFILE")
                                                                    ?.map(m => m.mediaUrl)}
                                                                showArrows={true}
                                                            />
                                                        </div>


                                                    </div>

                                                )}

                                            </div>
                                            {stylists?.media?.some(m => m.mediaType === "WORK") && (
                                                <div className="mt-10">
                                                    <h3 className="text-md font-semibold text-gray-800 dark:text-gray-100 mb-3">
                                                        Work Showcase
                                                    </h3>
                                                    <LeaderCard
                                                        stylistsmedia={stylists.media
                                                            ?.filter(m => m.mediaType === "WORK")
                                                            ?.map(m => ({ image: m.mediaUrl, caption: m.caption }))}
                                                    />
                                                </div>
                                            )}
                                        </>
                                    );
                                })}
                        </div> */}


                        <div className="flex-1 flex flex-col md:flex-row md:gap-12 gap-8">
                            <div className="flex-1 md:pl-8 md:border-l border-gray-200 dark:border-gray-700 pr-2">
                                <div className="flex items-center justify-between mb-4">

                                    <h3 className="text-md font-semibold text-gray-800 dark:text-gray-100">
                                        Quiz
                                    </h3>
                                    {data?.quizSessions?.[0] && (
                                        <div className="flex items-center gap-3 text-sm">
                                            <span
                                                className={`px-2 py-1 rounded-md text-xs font-medium
                                                                    ${data.quizSessions[0].status === "COMPLETED"
                                                        ? "bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-200"
                                                        : data.quizSessions[0].status === "STARTED"
                                                            ? "bg-amber-100 text-amber-700 dark:bg-amber-800 dark:text-amber-200"
                                                            : "bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-200"
                                                    }`}
                                            >
                                                {data.quizSessions[0].status === "COMPLETED"
                                                    ? "Taken"
                                                    : data.quizSessions[0].status === "STARTED"
                                                        ? "Started"
                                                        : "Not Taken"}
                                            </span>
                                            {data.quizSessions[0].completedAt && (
                                                <span className="text-gray-500 dark:text-gray-400 text-xs">
                                                    {new Date(data.quizSessions[0].completedAt).toLocaleString()}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {data?.quizSessions?.length > 0 && (
                                    <div className="max-h-[400px] overflow-y-auto">
                                        <div className="space-y-4">
                                            {Object.entries(data.quizSessions[0].answers)
                                                .sort(([a], [b]) => {
                                                    const numA = parseInt(a.replace("Q", ""), 12);
                                                    const numB = parseInt(b.replace("Q", ""), 12);
                                                    return numA - numB;
                                                })
                                                ?.map(([question, answer]) => (
                                                    <div
                                                        key={question}
                                                        className="p-4 rounded-lg bg-gray-50 dark:bg-gray-800 shadow-sm"
                                                    >
                                                        <h4 className="text-sm text-gray-500 dark:text-gray-400">
                                                            {question}
                                                        </h4>
                                                        <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                                                            {answer}
                                                        </p>
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {stylists && (
                                <div className="flex-1 flex flex-col gap-6 items-center">
                                    <div className="flex flex-col items-center text-center">
                                        <h2 className="text-xl font-semibold text-gray-800 dark:text-white">
                                            {stylists.displayName}
                                        </h2>
                                        <p className="text-sm text-gray-600 dark:text-gray-300">
                                            {stylists.persona}
                                        </p>
                                        <p className="text-xs text-gray-400 dark:text-gray-500">
                                            {stylists.ethos}
                                        </p>
                                    </div>

                                    <div className="w-full max-w-[250px]">
                                        <LeaderCard
                                            images={stylists.media
                                                ?.filter((m) => m.mediaType === "PROFILE")
                                                ?.map((m) => m.mediaUrl)}
                                            showArrows={true}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>
                    {stylists?.media?.some(m => m.mediaType === "WORK") && (
                        <div className="mt-10">
                            <h3 className="text-md font-semibold text-gray-800 dark:text-gray-100 mb-3">
                                Work Inspiration
                            </h3>
                            <LeaderCard
                                stylistsmedia={stylists.media
                                    ?.filter(m => m.mediaType === "WORK")
                                    ?.map(m => ({ image: m.mediaUrl, caption: m.caption }))}
                            />
                        </div>
                    )}
                </div>
            )}

        </>
    );
};
export default InsiderDetails;



//  <div className="flex-1 md:pl-8 md:border-l border-gray-200 dark:border-gray-700 pr-2">
//                                 <h3 className="text-md font-semibold text-gray-800 dark:text-gray-100 mb-4">
//                                     Quiz Sessions
//                                 </h3>

//                                 {data?.quizSessions?.length > 0 ? (
//                                     <div className="space-y-8 max-h-[600px] overflow-y-auto pr-2">
//                                         {data.quizSessions.map((session, idx) => (
//                                             <div

//                                                 key={session.sessionId}
//                                                 className="p-4 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm"
//                                             >
//                                                 {/* Header */}
//                                                 <div className="flex items-center justify-between mb-4">
//                                                     <div className="flex items-center gap-3 text-sm">
//                                                         {/* Status */}
//                                                         <span
//                                                             className={`px-2 py-1 rounded-md text-xs font-medium
//                                                                     ${session.status === "COMPLETED"
//                                                                     ? "bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-200"
//                                                                     : session.status === "STARTED"
//                                                                         ? "bg-amber-100 text-amber-700 dark:bg-amber-800 dark:text-amber-200"
//                                                                         : "bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-200"
//                                                                 }`}
//                                                         >
//                                                             {session.status === "COMPLETED"
//                                                                 ? "Taken"
//                                                                 : session.status === "STARTED"
//                                                                     ? "Started"
//                                                                     : "Not Taken"}
//                                                         </span>


//                                                         {/* Completed At */}
//                                                         {session.completedAt && (
//                                                             <span className="text-gray-500 dark:text-gray-400 text-xs">
//                                                                 {new Date(session.completedAt).toLocaleString()}
//                                                             </span>
//                                                         )}
//                                                     </div>

//                                                     {/* Matched Stylist */}
//                                                     {session.matchedStylist && (
//                                                         <span className="text-sm font-medium text-indigo-600 dark:text-indigo-400">
//                                                             Matched: @{session.matchedStylist}
//                                                         </span>
//                                                     )}
//                                                 </div>

//                                                 {/* Answers */}
//                                                 <div className="space-y-3">
//                                                     {Object.entries(session.answers)
//                                                         .sort(([a], [b]) => {
//                                                             const numA = parseInt(a.replace("Q", ""), 10);
//                                                             const numB = parseInt(b.replace("Q", ""), 10);
//                                                             return numA - numB;
//                                                         })
//                                                         .map(([question, answer]) => (
//                                                             <div
//                                                                 key={question}
//                                                                 className="p-3 rounded-lg bg-gray-50 dark:bg-gray-800"
//                                                             >
//                                                                 <h4 className="text-sm text-gray-500 dark:text-gray-400">
//                                                                     {question}
//                                                                 </h4>
//                                                                 <p className="text-base font-medium text-gray-900 dark:text-gray-100">
//                                                                     {answer}
//                                                                 </p>
//                                                             </div>
//                                                         ))}
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 ) : (
//                                     <p className="text-gray-500 dark:text-gray-400 text-sm">
//                                         No quiz sessions available.
//                                     </p>
//                                 )}
//                             </div>

{/* <div className="flex-1 md:pl-8 md:border-l border-gray-200 dark:border-gray-700 pr-2">
                                <h3 className="text-md font-semibold text-gray-800 dark:text-gray-100 mb-1">
                                    Quiz
                                </h3>
                                {data?.quizSessions?.length > 0 && (
                                    <div className="max-h-[400px] overflow-y-auto">
                                        <div className="space-y-4">
                                            {Object.entries(data?.quizSessions[0].answers)
                                                .sort(([a], [b]) => {
                                                    const numA = parseInt(a.replace("Q", ""), 10);
                                                    const numB = parseInt(b.replace("Q", ""), 10);
                                                    return numA - numB;
                                                })
                                                .map(([question, answer]) => (
                                                    <div
                                                        key={question}
                                                        className="p-4 rounded-lg bg-gray-50 dark:bg-gray-800 shadow-sm"
                                                    >
                                                        <h4 className="text-sm text-gray-500 dark:text-gray-400">
                                                            {question}
                                                        </h4>
                                                        <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                                                            {answer}
                                                        </p>
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                )}
                            </div> */}











// <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md mx-auto h-full overflow-auto">
//                     {/* Layout: Left side (image + personal info), Right side (body details) */}
//                     <div className="flex flex-col md:flex-row gap-8">
//                         <div className="flex flex-col items-end md:items-start gap-6 w-full md:w-1/6">
//                             <div className="w-40 h-40 overflow-hidden rounded-lg shadow-lg bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
//                                 <img
//                                     src={
//                                         data?.profile?.profile?.profileDpSignedUrl
//                                             ? data.profile?.profile?.profileDpSignedUrl
//                                             : `https://ui-avatars.com/api/?name=${encodeURIComponent(
//                                                 `${data?.firstName || ""} ${data?.lastName || ""}`
//                                             )}&background=a8936a&color=fff`
//                                     }
//                                     alt="Profile"
//                                     className="w-full h-full object-scale-down"
//                                 />


//                             </div>

//                             {/* Personal Details */}
//                             <div className="space-y-4 w-full">
//                                 <div>
//                                     <h3 className="text-sm text-gray-500 dark:text-gray-400">Full Name</h3>
//                                     <p className="text-base font-medium text-gray-900 dark:text-gray-100">
//                                         {data?.firstName} {data?.lastName}
//                                     </p>
//                                 </div>
//                                 <div>
//                                     <h3 className="text-sm text-gray-500 dark:text-gray-400">Email</h3>
//                                     <p className="text-base font-medium text-gray-900 dark:text-gray-100">
//                                         {data?.email}
//                                     </p>
//                                 </div>
//                                 <div>
//                                     <h3 className="text-sm text-gray-500 dark:text-gray-400">Referral Code</h3>
//                                     <p className="flex items-center text-base font-medium text-gray-900 dark:text-gray-100 gap-2">
//                                         {data?.refCode}

//                                         <div
//                                             className="flex items-center justify-center w-8 h-8 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer"
//                                             onClick={handleCopy}
//                                         >
//                                             <CopyIcon
//                                                 className={`size-5 transition-colors ${copied
//                                                     ? " text-green-600 dark:text-green-400"
//                                                     : "text-gray-800 dark:text-white/90"
//                                                     }`}
//                                             />
//                                         </div>

//                                         {copied && (
//                                             <span className="ml-2 text-sm text-green-600 dark:text-green-400">
//                                                 Copied!
//                                             </span>
//                                         )}
//                                     </p>
//                                 </div>

//                             </div>
//                         </div>
//                         <div className="flex flex-col md:flex-row md:gap-12 gap-8">
//                             {/* Left: Quiz Answers */}
//                             <div className="flex-1 md:pl-8 md:border-l border-gray-200 dark:border-gray-700 pr-2">
//                                 <h3 className="text-md font-semibold text-gray-800 dark:text-gray-100 mb-1">
//                                     Quiz
//                                 </h3>
//                                 {data?.quizSessions?.length > 0 && (
//                                     <div className="max-h-[400px] overflow-y-auto">
//                                         <div className="space-y-4">
//                                             {Object.entries(data?.quizSessions[0].answers)
//                                                 .sort(([a], [b]) => {
//                                                     const numA = parseInt(a.replace("Q", ""), 10);
//                                                     const numB = parseInt(b.replace("Q", ""), 10);
//                                                     return numA - numB;
//                                                 })
//                                                 .map(([question, answer]) => (
//                                                     <div
//                                                         key={question}
//                                                         className="p-4 rounded-lg bg-gray-50 dark:bg-gray-800 shadow-sm"
//                                                     >
//                                                         <h4 className="text-sm text-gray-500 dark:text-gray-400">
//                                                             {question}
//                                                         </h4>
//                                                         <p className="text-base font-medium text-gray-900 dark:text-gray-100">
//                                                             {answer}
//                                                         </p>
//                                                     </div>
//                                                 ))}
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>

//                             {/* Right: Stylist Profile */}
//                             {stylist && (
//                                 <div className="flex-1 flex flex-col gap-6 items-center">
//                                     {/* Stylist Name & Persona */}
//                                     <div className="flex flex-col items-center text-center">
//                                         <h2 className="text-xl font-semibold text-gray-800 dark:text-white">
//                                             {stylist.displayName}
//                                         </h2>
//                                         <p className="text-sm text-gray-600 dark:text-gray-300">
//                                             {stylist.persona}
//                                         </p>
//                                         <p className="text-xs text-gray-400 dark:text-gray-500">
//                                             {stylist.ethos}
//                                         </p>
//                                     </div>

//                                     {/* Profile Images Slider */}
//                                     <div className="w-full max-w-[250px]">
//                                         <LeaderCard
//                                             images={stylist.media
//                                                 ?.filter((m) => m.mediaType === "PROFILE")
//                                                 ?.map((m) => m.mediaUrl)}
//                                             showArrows={true}
//                                         />
//                                     </div>
//                                 </div>
//                             )}
//                         </div>


//                     </div>
//                     {/* Bottom section: Work Images */}
//                     {stylist?.media?.some(m => m.mediaType === "WORK") && (
//                         <div>
//                             <h3 className="text-md font-semibold text-gray-800 dark:text-gray-100 mb-3">
//                                 Work Inspiration
//                             </h3>
//                             <LeaderCard
//                                 stylistsmedia={stylist.media
//                                     ?.filter(m => m.mediaType === "WORK")
//                                     ?.map(m => ({ image: m.mediaUrl, caption: m.caption }))}
//                             />
//                         </div>
//                     )}
//                 </div>